var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVimeo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 136,
    viewBox: "0 0 136 136",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M135.3 67.6C135.3 104.8 105.1 135.1 67.8 135.1C30.6 135.1 0.299988 104.8 0.299988 67.6C0.299988 30.3 30.6 0.0999756 67.8 0.0999756C105.1 0.0999756 135.3 30.3 135.3 67.6Z",
    fill: "#1AB7EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M111.4 50.4C111 59.2667 104.833 71.4 92.9 86.8C80.5 102.867 70.0333 110.9 61.5 110.9C56.1667 110.9 51.6667 106 48 96.2C45.6 87.2 43.1667 78.2333 40.7 69.3C37.9667 59.5 35.0333 54.6 31.9 54.6C31.2333 54.6 28.8667 56.0334 24.8 58.9L20.5 53.4C24.9667 49.4667 29.4 45.5 33.8 41.5C39.8 36.3667 44.3 33.6667 47.3 33.4C54.3667 32.6667 58.7 37.5 60.3 47.9C62.1 59.0334 63.3333 65.9667 64 68.7C66.0667 77.9667 68.3333 82.6 70.8 82.6C72.6667 82.6 75.5 79.6 79.3 73.6C83.1 67.6 85.1667 63.0334 85.5 59.9C86.0333 54.7 83.9667 52.1 79.3 52.1C77.1667 52.1 74.9333 52.6 72.6 53.6C77.0667 38.9333 85.6 31.8 98.2 32.2C107.6 32.4667 112 38.5334 111.4 50.4V50.4Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVimeo);
export default __webpack_public_path__ + "static/media/vimeo.539e4985d2c0dced329fe8bfebf273db.svg";
export { ForwardRef as ReactComponent };